import React, { useState, useMemo } from "react";
import { useModeloCampanhas } from "./hooks/useModeloCampanhas";
import { CardModeloCampanha } from "./components/CardModeloCampanha";
import { useMensagensService } from "../../services/mensagensService";
import {
  Spin,
  Alert,
  Row,
  Col,
  Button,
  Typography,
  Empty,
  Skeleton,
  Flex,
  Switch,
} from "antd";
import { Container } from "../ViewGerenciarPostagens/styles";
import { usePermissao } from "../../uteis/permissaoAdm/usePermissao";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";
import { useMediaQuery } from "@mui/material";
import { ModalAdicionarModeloCampanha } from "./components/ModalAdicionarModeloCampanha";
import { ModalEditarModeloCampanha } from "./components/ModalEditarModeloCampanha";
import { ModeloCampanha } from "../../services/modeloCampanhasService";

const { Title, Text } = Typography;

export default function ViewGerenciarModeloCampanhas() {
  const {
    modeloCampanhas,
    loading,
    erro,
    toggleAtivo,
    excluirModeloCampanha,
    atualizarModeloCampanha,
    cadastrarModeloCampanha,
  } = useModeloCampanhas();

  const [modalAdicionarAberto, setModalAdicionarAberto] = useState(false);
  const [modalEditarAberto, setModalEditarAberto] = useState(false);
  const [modeloSelecionado, setModeloSelecionado] = useState<ModeloCampanha | null>(null);
  const [mostrarApenasAtivos, setMostrarApenasAtivos] = useState(false);
  const { sucesso, aviso, contextHolder } = useMensagensService();

  const { isLoading: isTokenLoading, isValid } = usePermissao("ADM");
  const isMobile = useMediaQuery("(max-width:600px)");

  // 🔹 Filtro de exibição
  const modelosFiltrados = useMemo(() => {
    let lista = [...modeloCampanhas];
    // Ordena: ativos primeiro
    lista.sort((a, b) => Number(b.ativo) - Number(a.ativo));
    // Filtro de ativos
    if (mostrarApenasAtivos) {
      lista = lista.filter((m) => m.ativo);
    }
    return lista;
  }, [modeloCampanhas, mostrarApenasAtivos]);

  // 🔹 Abrir modal de edição
  const handleEditar = (modelo: ModeloCampanha) => {
    setModeloSelecionado(modelo);
    setModalEditarAberto(true);
  };

  // 🔹 Ao salvar novo modelo
const handleAdicionar = async (dados: Partial<ModeloCampanha>) => {
  const sucessoCadastro = await cadastrarModeloCampanha(dados);
  if (sucessoCadastro) setModalAdicionarAberto(false);
  return sucessoCadastro; // ✅ agora retorna Promise<boolean>
};


// 🔹 Ao salvar edição
const handleSalvarEdicao = async (id: number, dados: Partial<ModeloCampanha>) => {
  const sucessoAtualizacao = await atualizarModeloCampanha(id, dados);
  return !!sucessoAtualizacao; // ✅ deixa o modal controlar mensagens e fechamento
};



  if ((loading && isTokenLoading) || !isValid) {
    return <Skeleton active />;
  }

  return (
    <Container>
      <div className="p-8">
        {/* 🔹 Cabeçalho */}
        <Row>
          <Col span={5}>
            <Flex align="center" justify="center" style={{ marginTop: 15 }}>
              <a href={`/marketing`}>
                <ArrowBackIcon color="primary" />
              </a>
            </Flex>
          </Col>
          <Col span={12}>
            <Flex align="center" justify="center">
              <HomeIcon color="primary" fontSize="large" />
              <Title
                style={{
                  marginLeft: 10,
                  marginTop: 10,
                  fontSize: isMobile ? "1rem" : "2rem",
                  color: "rgb(0, 54, 68)",
                }}
                level={3}
              >
                Gerenciar Modelos de Campanhas
              </Title>
            </Flex>
          </Col>
        </Row>

        {/* 🔹 Ações */}
        <Row
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 10,
            marginBottom: 20,
          }}
        >
          <Col>
            <Flex align="center" gap={8}>
              <Switch
                checked={mostrarApenasAtivos}
                onChange={setMostrarApenasAtivos}
              />
              <Text>Mostrar apenas ativos</Text>
            </Flex>
          </Col>

          <Col>
            <Button
              type="primary"
              onClick={() => setModalAdicionarAberto(true)}
            >
              + Modelo de Campanha
            </Button>
          </Col>
        </Row>

        {/* 🔹 Conteúdo principal */}
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <Spin size="large" />
          </div>
        ) : erro ? (
          <Alert message="Erro ao carregar modelos" description={erro} type="error" showIcon />
        ) : modelosFiltrados.length === 0 ? (
          <div className="flex flex-col justify-center items-center h-64 text-center">
            <Empty
              description={
                <span className="text-gray-500">
                  Nenhum modelo de campanha encontrado
                </span>
              }
            />
          </div>
        ) : (
          <Row gutter={[16, 16]}>
            {modelosFiltrados.map((modeloCampanha) => (
              <Col key={modeloCampanha.id} xs={24} sm={12} lg={8}>
                <CardModeloCampanha
                  modeloCampanha={modeloCampanha}
                  onToggleAtivo={() =>
                    toggleAtivo(modeloCampanha.id, !modeloCampanha.ativo)
                  }
                  onEditar={() => handleEditar(modeloCampanha)}
                  
                />
              </Col>
            ))}
          </Row>
        )}
      </div>

      {/* 🔹 Modal Adicionar */}
      <ModalAdicionarModeloCampanha
        open={modalAdicionarAberto}
        onClose={() => setModalAdicionarAberto(false)}
        onSubmit={handleAdicionar}
      />

      {/* 🔹 Modal Editar */}
      {modeloSelecionado && (
        <ModalEditarModeloCampanha
          open={modalEditarAberto}
          onClose={() => setModalEditarAberto(false)}
          modeloCampanha={modeloSelecionado}
          onSubmit={handleSalvarEdicao}
        />

      )}
    </Container>
  );
}
